import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const wrapper = css`
  margin-top: -1rem;
`;
export const container = css`
  @media (max-width: ${dimensions.widescreen}) {
    gap: 1rem;
  }
  @media (min-width: ${dimensions.desktop}) {
    display: flex;
    justify-content: space-between;
  }
`;

export const infoContainer = {
  base: css`
    @media (max-width: ${dimensions.phoneLargeMax}) {
      margin-top: 2.5rem;
    }
    @media (min-width: ${dimensions.desktop}) {
      width: 26rem;
      position: sticky;
      right: 0;
      top: 9.5rem;
      height: fit-content;
    }
  `,
  withSetupBar: css`
    @media (min-width: ${dimensions.desktop}) {
      top: 12.5rem;
    }
  `,
  withModal: css`
    @media (min-width: ${dimensions.desktop}) {
      top: 2rem;
    }
  `,
};

export const skeletonImage = css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    height: 20rem;
  }
`;
